"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registeredProviders = exports.unmatched = exports.dropped = exports.claimed = void 0;
const agno_1 = require("./providers/agno");
const ai_sdk_1 = require("./providers/ai-sdk");
const anthropic_1 = require("./providers/anthropic");
const gemini_1 = require("./providers/gemini");
const langchain_1 = require("./providers/langchain");
const langfuse_agent_plugins_1 = require("./providers/langfuse-agent-plugins");
const openai_1 = require("./providers/openai");
const otel_genai_1 = require("./providers/otel-genai");
const pydantic_ai_1 = require("./providers/pydantic-ai");
const semantic_kernel_1 = require("./providers/semantic-kernel");
var io_convention_1 = require("./io-convention");
Object.defineProperty(exports, "claimed", { enumerable: true, get: function () { return io_convention_1.claimed; } });
Object.defineProperty(exports, "dropped", { enumerable: true, get: function () { return io_convention_1.dropped; } });
Object.defineProperty(exports, "unmatched", { enumerable: true, get: function () { return io_convention_1.unmatched; } });
/**
 * All registered provider conventions, in deliberate order: common providers
 * first, so every fold checks the hot dialects before the long tail.
 * Part and tool-definition shapes are mostly disjoint, but message claims are
 * intentionally exclusive: the first provider claiming a conversation owns
 * that carrier. Keep this list ordered from the most specific/common root
 * envelopes to the generic tail; parser context then tries the selected
 * provider first while normalizing nested parts.
 * Adding a provider is a directory plus one entry here; `registry.test.ts`
 * asserts folder <-> registry parity.
 *
 * Eager: provider files depend on canonical part builders and JSON helpers,
 * never on `normalize/message.ts`, `normalize/part.ts`, or the accumulator
 * collector, which import this registry, so there is no import cycle to
 * protect against.
 */
exports.registeredProviders = [
    openai_1.openAiProvider,
    anthropic_1.anthropicProvider,
    gemini_1.geminiProvider,
    langchain_1.langchainProvider,
    ai_sdk_1.aiSdkProvider,
    otel_genai_1.otelGenaiProvider,
    pydantic_ai_1.pydanticAiProvider,
    semantic_kernel_1.semanticKernelProvider,
    agno_1.agnoProvider,
    langfuse_agent_plugins_1.langfuseAgentPluginsProvider,
];
